import { useState, useEffect, useCallback } from 'react';
import { Play, Film } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function MediaCard({ item }) {
  return (
    <div data-testid={`media-card-${item.id}`} className="bg-[#122036] border border-[#d4af37]/20 rounded-xl overflow-hidden">
      <div className="embed-container">
        <iframe
          src={item.embed_url}
          title={item.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <div className="p-6">
        <h3 className="font-['Cormorant_Garamond'] text-xl text-[#fdfbf7] mb-1">{item.title}</h3>
        {item.artist_name && <p className="text-[#d4af37] text-sm mb-2">{item.artist_name}</p>}
        <p className="text-[#a3b1c6] text-sm">{item.description}</p>
      </div>
    </div>
  );
}

export default function MediaSection() {
  const [media, setMedia] = useState([]);

  const fetchMedia = useCallback(() => {
    axios.get(`${API}/media`).then(r => setMedia(r.data)).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- API is a module constant

  useEffect(() => { fetchMedia(); }, [fetchMedia]);

  return (
    <section id="media" data-testid="media-section" className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.2em] text-[#d4af37] mb-4 flex items-center justify-center gap-2">
            <Film className="w-4 h-4" /> Listen & Watch
          </p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#fdfbf7] mb-4 tracking-tight">Featured Performances</h2>
          <p className="text-[#a3b1c6] max-w-xl mx-auto text-base">Immerse yourself in the finest sitar performances</p>
        </div>

        {media.length === 0 ? (
          <div className="text-center py-20 text-[#a3b1c6]">
            <Play className="w-12 h-12 mx-auto mb-4 opacity-40" />
            <p>Media content coming soon</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {media.map(item => <MediaCard key={item.id} item={item} />)}
          </div>
        )}
      </div>
      <div className="section-divider mt-24 md:mt-32 max-w-4xl mx-auto" />
    </section>
  );
}
